export default __webpack_public_path__ + "static/media/girl1.b5fc729f.svg";